<template>
  <div class="advance-search-form">
    <div class="advance-search-form-title">
      <Icon type="ios-locate-outline" />
      <span>{{ $t('key31') }}</span>
    </div>
    <div class="advance-search-form-content">
      <Row type="flex" align="middle" v-for="(row, index) in conditions" :key="index">
        <Col class="col-and"><span v-if="index !== 0" class="and">AND</span></Col>
        <Col class="flex-1">
          <Input v-model="row.value">
            <Select v-model="row.key" slot="prepend" style="min-width: 100px">
              <Option v-for="field in fields" :key="field.key" :value="field.key">{{ field.label }}</Option>
            </Select>
          </Input>
        </Col>
        <Col class="flex">
          <div class="plus" @click="addCondition"><Icon type="md-add" /></div>
          <div class="minus" v-if="index > 0" @click="removeCondition($event, index)"><Icon type="md-remove" /></div>
        </Col>
      </Row>
    </div>
    <div class="advance-search-footer">
      <Button size="large" @click="resetConditions">{{ $t('key32') }}</Button>
      <Button size="large" type="primary" class="search-btn" :disabled="invalid" @click="search">{{ $t('btn.search') }}</Button>
    </div>
  </div>
</template>
<script>
  import utils from '@/utils/utils';
  export default {
    data() {
      return {
        conditions: [],
        fields: [
          {
            label: this.$i18n.t('columns.materialName'),
            key: 'BottleName',
          },
          {
            label: this.$i18n.t('page.materielNumber'),
            key: 'MaterielNumber',
          },
          {
            label: this.$i18n.t('columns.CASNumber'),
            key: 'CASNumber',
          },
          {
            label: this.$i18n.t('columns.barcode'),
            key: 'Barcode',
          },
          {
            label: this.$i18n.t('columns.bottleType'),
            key: 'BottleType',
          },
          {
            label: this.$i18n.t('columns.purity'),
            key: 'Purity',
          },
          {
            label: this.$i18n.t('page.supplier'),
            key: 'Supplier',
          },
          {
            label: this.$i18n.t('columns.producer'),
            key: 'Producer',
          },
        ],
      };
    },
    methods: {
      addCondition() {
        if (this.conditions.length === this.fields.length) return;
        this.conditions.push({
          key: '',
          value: '',
        });
      },
      removeCondition(event, index) {
        this.conditions.splice(index, 1);
        event.stopPropagation();
      },
      resetConditions() {
        this.conditions = [{ key: 'BottleName', value: '' }];
      },
      search() {
        if (this.invalid) return;
        const conditions = this.conditions
          .filter(item => item.key && item.value)
          .map(item => `${item.key}=${encodeURIComponent(item.value)}`)
          .join('&');
        utils.skipTo(`/search?advanceSearch=true&${conditions}`);
      },
      // 获取高级搜索条件
      getAdvanceSearchFields() {
        const params = utils.getParams();
        if (!params) return [];
        const conditions = params.map(item => {
          if (!item.includes('=')) return '';
          const condition = item.split('=');
          if (condition[0] == 'advanceSearch') return '';
          return {
            key: condition[0],
            value: decodeURIComponent(condition[1]),
          };
        });
        return conditions.filter(item => Boolean(item));
      },
    },
    computed: {
      invalid() {
        return !this.conditions.some(item => item.key && item.value);
      },
    },
    mounted() {
      const isAdvanceSearch = utils.getParams('advanceSearch');
      if (!isAdvanceSearch) {
        this.conditions = [{ key: 'BottleName', value: '' }];
        return;
      }
      const conditions = this.getAdvanceSearchFields();
      if (conditions.length) {
        this.conditions = conditions;
      }
    },
  };
</script>
<style lang="less" scoped>
  .advance-search-form {
    width: 783px;
    .advance-search-form-title {
      padding: 12px;
      font-size: 16px;
      border-bottom: 1px solid #dbdbdb;
      display: flex;
      align-items: center;
      .ivu-icon {
        font-size: 18px;
        margin-right: 2px;
      }
    }
    .advance-search-form-content {
      padding: 12px;
      font-size: 14px;
      .and {
        color: #8d88a1;
        position: relative;
        top: 3px;
      }
      .ivu-row-flex {
        margin-bottom: 12px;
      }
      .col-and {
        width: 30px;
        margin-left: 8px;
      }
      .flex-1 {
        margin-left: 20px;
      }
      .flex {
        display: flex;
        width: 65px;
        padding: 0 8px;
        > div {
          cursor: pointer;
          color: #424242;
          font-size: 26px;
          &:hover {
            color: #000;
          }
        }
      }
    }
    .advance-search-footer {
      text-align: center;
      padding: 20px 0;
      margin: 0 20px;
      border-top: 1px solid #dbdbdb;
      .ivu-btn {
        margin-left: 8px;
      }
      .search-btn {
        min-width: 87px;
      }
    }
  }
</style>
